export enum UrgentFollowUpTabs {
  Open = 'Open',
  Cold = 'Cold',
  Done = 'Done',
}
